import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Exercise } from 'src/app/interfaces/exercise';
import { GymMachine } from 'src/app/interfaces/gym-machine';
import { MuscleGroup } from 'src/app/interfaces/muscle-group';
import { Tutorial } from 'src/app/interfaces/tutorial';
import { ExerciseService } from 'src/app/services/exercise.service';
import { StateService } from 'src/app/services/state.service';
import { ToastService } from 'src/app/services/toast.service';
import { TutorialsService } from 'src/app/services/tutorials.service';

@Component({
  selector: 'app-exercise-form-modal',
  templateUrl: './exercise-form-modal.component.html',
  styleUrls: ['./exercise-form-modal.component.scss'],
})
export class ExerciseFormModalComponent implements OnInit, OnChanges {
  @Input() editing: boolean | undefined;
  @Input() exercise: Exercise | undefined;

  @Output() editingChange = new EventEmitter<any>();

  exerciseForm: UntypedFormGroup;

  isMobile: boolean = false;

  formatTranslation: any = {
    SHORT_VIDEO: 'Video Corto',
  };

  muscleGroups: MuscleGroup[] = [];
  gymMachines: GymMachine[] = [];

  constructor(
    private fb: UntypedFormBuilder,
    private deviceService: DeviceDetectorService,
    private exerciseService: ExerciseService,
    private tutorialService: TutorialsService,
    private toastService: ToastService,
    private stateService: StateService
  ) {
    this.exerciseForm = this.fb.group({
      name: ['', [Validators.required]],
      description: ['', []],
      muscleGroup: [null, [Validators.required]],
      gymMachine: [null],
    });
  }

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobile();
    this.getMuscleGroups();
    this.getGymMachine();

    const modal = document.getElementById('exerciseFormModal');

    modal?.addEventListener('hidden.bs.modal', () => {
      this.name.setValue('');
      this.description.setValue('');
      this.muscleGroup.setValue(null);
      this.gymMachine.setValue(null);
    });

    modal?.addEventListener('shown.bs.modal', () => {
      if (this.editing) {
        this.exerciseService.getExerciseDetail(this.exercise?.id!).subscribe({
          next: (response) => {
            this.exercise = response;
            this.name.setValue(this.exercise!.name);
            this.description.setValue(this.exercise!.description);
            const muscleGroup = this.muscleGroups.filter(
              (mg: MuscleGroup) => mg.name == this.exercise!.muscleGroup
            )[0];

            this.muscleGroup.setValue(muscleGroup.id!);
            this.gymMachine.setValue(this.exercise!.gymMachineId);
          },
        });
      }
    });
  }

  getGymMachine(): void {
    this.exerciseService.getGymMachine().subscribe({
      next: (response: any) => {
        this.gymMachines = response;
      },
      error: (_error: Error) => {
        this.toastService.alert(
          'Ha ocurrido un error trayendo las máquinas . Si el error persiste contactarse con el soporte.'
        );
      },
    });
  }

  getMuscleGroups(): void {
    this.exerciseService.getMuscleGroups().subscribe({
      next: (response: any) => {
        this.muscleGroups = response.muscleGroup;
      },
      error: (_error: Error) => {
        this.toastService.alert(
          'Ha ocurrido un error trayendo los grupos musculares. Si el error persiste contactarse con el soporte.'
        );
      },
    });
  }

  ngOnChanges(changes: SimpleChanges): void {}

  editExercise() {
    if (
      confirm(
        'Estas seguro que quieres editar el ejercicio? Si aceptas se modificara en todas las rutinas que ya exista el ejercicio.'
      )
    ) {
      this.exercise!.name = this.name.value;
      this.exercise!.description = this.description.value;
      this.exercise!.muscleGroupId = parseInt(this.muscleGroup.value);
      this.exercise!.gymMachineId = parseInt(this.gymMachine.value);

      this.exerciseService.updateExercise(this.exercise!).subscribe({
        next: () => {
          this.toastService.success('Se editó correctamente el ejercicio');
        },
        error: () => {
          this.toastService.alert(
            'Hubo un error en la Edición de tu ejercicio, si el error persiste contactate con el soporte tecnico.'
          );
        },
      });
    }
  }

  createExercise() {
    const exercise: Exercise = {
      name: this.name.value,
      description: this.description.value,
      muscleGroupId: parseInt(this.muscleGroup.value),
      gymMachineId: parseInt(this.gymMachine.value),
    };

    this.exerciseService.createExercise(exercise).subscribe({
      next: () => {
        this.toastService.success('Creaste con éxito el ejercicio');
      },
      error: () => {
        this.toastService.alert(
          'Hubo un error en la creación de tu ejercicio, si el error persiste contactate con el soporte tecnico.'
        );
      },
    });
  }

  onSubmit() {
    if (this.editing) {
      this.editExercise();
    } else {
      this.createExercise();
    }
  }

  clearAllFields() {
    this.name.setValue('');
    this.description.setValue('');
    this.muscleGroup.setValue(null);
    this.gymMachine.setValue(null);

    this.editing = false;
    this.editingChange.emit(false);
  }

  selectTutorial(tutorial: Tutorial) {}

  addTutorial() {
    this.stateService.selectedExerciseToAddTutorial = this.exercise;
  }

  deleteTutorial(tutorial: Tutorial) {
    this.tutorialService.deleteTutorial(tutorial).subscribe({
      next: () => {
        this.toastService.success('Se elimino con éxito el tutorial.');
        this.exercise!.tutorials = [];
      },
      error: () => {
        this.toastService.alert('No se pudo eliminar con éxito el tutorial.');
      },
    });
  }

  get name() {
    return this.exerciseForm.controls['name'];
  }

  get description() {
    return this.exerciseForm.controls['description'];
  }

  get muscleGroup() {
    return this.exerciseForm.controls['muscleGroup'];
  }

  get gymMachine() {
    return this.exerciseForm.controls['gymMachine'];
  }
}
